import { createPlugin } from "@openreply/internationalization";

import { createIntl } from "~/intl/index";

export const translator = createIntl();

export const plugin = createPlugin(translator);
